import useQuizSettings from 'hooks/API/GET/useQuizSettings';
import { memo, useMemo } from 'react';
// import useQueryParams from 'hooks/useQueryParams';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { AppRadioBox } from 'components';
import BoardsList, { AppBoards } from 'components/BoardsList';
import YearsList from 'components/YearsList';

function QuizSectionsSettings({
  handleChange,
  selectedItemId,
  prefix = '',
  selectedPaperId = '',
  extras = {},
}) {
  const { setSettings, settings } = extras || {};
  const { quizID, courseID } = useParams();

  // const queryParams = useQueryParams();
  // const paperId = queryParams.get('paperId');

  const { isLoading, data } = useQuizSettings({
    enabled: true,
    quizId: quizID,
    configs: { params: { courseID } },
  });

  const __sections = data?.data?.sections;
  const __papers = data?.data?.papers;

  const __selectedItemId = useMemo(() => {
    return __sections?.find((s) => s?._id === selectedItemId);
  }, [selectedItemId, __sections]);

  const __selectedPaper = useMemo(() => {
    return __papers?.find((p) => p?._id === selectedPaperId);
  }, [selectedPaperId, __papers]);

  if (!quizID) return null;

  if (isLoading) return 'Loading...';

  return (
    <>
      <QuestionCategories data={data?.data} handleChange={setSettings} settings={settings} />
      <PastPapersConfig data={data?.data} handleChange={setSettings} settings={settings} />
      {__sections?.length > 0 && (
        <>
          {__selectedPaper && (
            <div class="row my-4">
              <div class="col-12">
                <label>
                  Paper name: <strong>{__selectedPaper?.value}</strong>
                </label>
              </div>
            </div>
          )}
          <div>
            <label>Sections</label>
            <br />
            <AppRadioBox
              inputProps={{
                name: `quizSection${prefix}`,
                checked: !__selectedItemId,
                onChange: () => handleChange(null),
              }}
              labelProps={{ label: 'No Section' }}
            />
            {__sections.map((s) => {
              return (
                <AppRadioBox
                  inputProps={{
                    key: s?._id,
                    name: `quizSection${prefix}`,
                    checked: __selectedItemId?._id === s?._id,
                    onChange: () => handleChange(s?._id),
                  }}
                  labelProps={{ label: s.value }}
                />
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

function QuestionCategories({ data, settings = {}, handleChange }) {
  if (
    ['mock_test', 'question_bank'].includes(data?.quizCategory) &&
    data?.class?.est?.key === 'uk'
  ) {
    return (
      <>
        <div className="row">
          <div className="col-6">
            <label>Difficulty level</label>
            <select
              value={settings.difficultyLevel}
              onChange={(event) => {
                const difficultyLevel = event.target.value;
                handleChange({ difficultyLevel });
              }}
            >
              <option value="">Select</option>
              {data?.course?.difficultyLevels?.map?.((obj) => (
                <option key={obj._id} value={obj.value}>
                  {obj.value}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6">
            <label>Assessment objective</label>
            <select
              value={settings.assessmentObjective}
              onChange={(event) => {
                const assessmentObjective = event.target.value;
                handleChange({ assessmentObjective });
              }}
            >
              <option value="">Select</option>
              {data?.course?.assessmentObjectives?.map?.((obj) => (
                <option key={obj._id} value={obj.value}>
                  {obj.value}
                </option>
              ))}
            </select>
          </div>
        </div>
      </>
    );
  }

  return null;
}
function PastPapersConfig({ data, settings = {}, handleChange }) {
  if (['previous_year'].includes(data?.quizCategory)) {
    const __boards = Object.values(AppBoards).reduce((a, x) => {
      return a.concat(x);
    }, []);

    const currentBoard = __boards.find((b) => b.value === data?.examBoard);

    return (
      <>
        <div className="row">
          {currentBoard?.label && (
            <div className="col-6">
              <label>
                Board: <strong>{currentBoard?.label}</strong>
              </label>
            </div>
          )}
          {data?.askedInYear && (
            <div className="col-6">
              <label>
                Year: <strong>{data?.askedInYear}</strong>
              </label>
            </div>
          )}
        </div>
      </>
    );
  }

  if (['past_papers'].includes(data?.quizCategory)) {
    return (
      <>
        <div className="row">
          <div className="col-6">
            <BoardsList value={settings.examBoard} handleChange={handleChange} />
          </div>
          <div className="col-6">
            <YearsList value={settings.askedInYear} handleChange={handleChange} />
          </div>
        </div>
      </>
    );
  }

  return null;
}

QuizSectionsSettings.defaultProps = {
  handleChange: () => {},
};

export default memo(QuizSectionsSettings);
